import { Event } from '../types';

export const openComponentEvent = new Event<{ elementId: string, componentId: string, facetId?: string }>();
